import classnames from 'classnames'

import styles from './dots.module.scss'

export interface dotsProps {
  className?: string
  activeDotIndex: number
  activeSlide: number
  totalSlideCount: number
}
const Dots = ({ className, activeDotIndex, activeSlide, totalSlideCount }: dotsProps) => {
  const wrapperClassName = classnames(styles.dotsWrapper, className)
  const dots = Array.from({ length: totalSlideCount }, (val, idx) => `${++idx}`)
  return (
    <div className={wrapperClassName}>
      {totalSlideCount > 5 &&
        dots.map((dot, index) => {
          if (index > 4) return null

          if (index === 0)
            return (
              <div
                key={index}
                className={classnames(activeSlide > 1 ? styles.dotSmall : styles.dot, {
                  [styles.activeDot]: activeDotIndex - 1 === index,
                })}
              ></div>
            )

          if (index === 4)
            return (
              <div
                key={index}
                className={classnames(activeSlide === totalSlideCount ? styles.dot : styles.dotSmall, {
                  [styles.activeDot]: activeDotIndex - 1 === index,
                })}
              ></div>
            )
          return (
            <div
              key={index}
              className={classnames(styles.dot, { [styles.activeDot]: activeDotIndex - 1 === index })}
            ></div>
          )
        })}
      {totalSlideCount <= 5 &&
        dots.map((_, index) => {
          return (
            <div
              key={index}
              className={classnames(styles.dot, { [styles.activeDot]: activeSlide - 1 === index })}
            ></div>
          )
        })}
    </div>
  )
}

export default Dots
